import React from 'react';
import { Icon } from '@alpha-recycling/component-library';

import {
  GridSearchHits,
  highlightableTextStyles,
  HighlightSearch,
  RowProps,
  SearchField,
  SearchFieldLabel,
  SearchGridContainer,
} from 'components/shared/List';
import { AssayListItem } from 'shared/types/assayListItem';
import { theme } from 'theme';
import { useSearchableAssaysFields } from './useSearchableAssaysFields';

export const AssaysSearchGrid = (props: React.PropsWithChildren<RowProps<AssayListItem>>) => {
  const assay = props.row!.original;
  const searchInput = props.table!.getState().globalFilter?.trim();
  const searchableFields = useSearchableAssaysFields({ assay, searchInput });

  return searchableFields.length ? (
    <SearchGridContainer>
      <GridSearchHits>
        <Icon name="Search" size="medium" fillColor={theme.colors.mineShaftLighter} />
        {searchableFields.map(
          field =>
            field && (
              <SearchField key={field.label}>
                <SearchFieldLabel>{field.label}</SearchFieldLabel>{' '}
                <HighlightSearch
                  className={highlightableTextStyles(false)}
                  searchWords={[field.matcher(searchInput)!]}
                  textToHighlight={field.value}
                />
              </SearchField>
            ),
        )}
      </GridSearchHits>
    </SearchGridContainer>
  ) : null;
};
